import { ProductPermission } from '@atlassian/forge-consent';

import { Box } from '@atlaskit/primitives';

export interface ScopesMetadataProps {
  action: string;
  entities: string[];
  descriptions: string[];
}

export interface ProductPermissionProps {
  service: string;
  scopes: ScopesMetadataProps[];
  serviceDisplayName: string;
}

const Scopes: React.FC = () => {
  const groupScopes: ProductPermissionProps[] = [
    {
      service: 'testservice',
      scopes: [
        {
          action: 'read',
          entities: ['entity1', 'entity2'],
          descriptions: ['Read access to entity1', 'Read access to entity2'],
        },
        {
          action: 'write',
          entities: ['entity3'],
          descriptions: ['Write access to entity3'],
        },
      ],
      serviceDisplayName: 'Test Service',
    },
  ];

  return (
    <Box>
      <ProductPermission
        service={'Example service'}
        scopes={groupScopes[0].scopes}
      />
    </Box>
  );
};

export default Scopes;
